import React from 'react';
import {render} from 'react-dom';

import '../../website-ui/i18n/config';

import {ArticlePreviewWrapper} from './components/article-preview/article-preview-wrapper';

export const renderArticleComments = ($commentsWrapper, id) => {
  if ($commentsWrapper) {
    render(<ArticlePreviewWrapper articleId={id} />, $commentsWrapper);
  }
};
